// extracted by mini-css-extract-plugin
export default {"inquiry":"inquiry_inquiry__VGkKT"};